const URL = (() => {
    const getParams = (location) => {
        if (!location) {
            return new URLSearchParams('');
        }
        return new URLSearchParams(location.search);
    };

    const makeParams = (params) => new URLSearchParams(params).toString();

    const getHub = (location) => {
        const { pathname } = location;

        if (pathname.includes('/partner')) {
            return 'Partner';
        }

        if (pathname.includes('/admin')) {
            return 'Admin';
        }

        if (pathname.includes('/globaladmin')) {
            return 'Global';
        }

        return 'none';
    };

    const isAdmin = (location) => {
        if (getHub(location) === 'Admin') {
            return true;
        }

        return false;
    };

    const isPartner = (location) => {
        if (getHub(location) === 'Partner') {
            return true;
        }

        return false;
    };

    const isReport = (location) => {
        const { pathname } = location;

        if (pathname.includes('/reports')) {
            return true;
        }

        return false;
    };

    return {
        getHub,
        getParams,
        isAdmin,
        isPartner,
        isReport,
        makeParams
    };
})();

export default URL;
